(() => {
  const bind = root => root.querySelectorAll('[data-tsh-hero-film]').forEach(frame => {
    if (frame.dataset.bound) return;
    frame.dataset.bound = 'true';
    const video = frame.querySelector('video');
    if (!video) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let requested = !motion.matches && !navigator.connection?.saveData;
    let visible = false;
    let failed = false;
    const render = () => {
      const playing = !video.paused;
      frame.classList.toggle('is-playing', playing);
    };
    const sync = () => {
      if (failed || !requested || !visible || document.hidden) { video.pause(); return; }
      if (!video.getAttribute('src')) {
        video.src = matchMedia('(max-width: 767px)').matches && video.dataset.srcMobile
          ? video.dataset.srcMobile : video.dataset.src;
      }
      video.muted = true;
      video.play().catch(() => { requested = false; render(); });
    };
    video.addEventListener('play', render);
    video.addEventListener('pause', render);
    video.addEventListener('timeupdate', () => {
      if (video.currentTime > .15) frame.classList.add('has-played');
    });
    video.addEventListener('error', () => {
      failed = true; video.pause();
      frame.classList.remove('is-playing','has-played');
      frame.querySelector('[role="status"]').textContent = 'Video unavailable. You can still explore below.';
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting; sync();
    }, {threshold: .12});
    observer.observe(frame);
    const onVisibility = () => sync();
    const onMotion = () => { if (motion.matches) { requested = false; sync(); } };
    document.addEventListener('visibilitychange', onVisibility);
    motion.addEventListener('change', onMotion);
    const onUnload = event => {
      if (!event.target.contains(frame)) return;
      observer.disconnect(); video.pause();
      document.removeEventListener('visibilitychange', onVisibility);
      motion.removeEventListener('change', onMotion);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);
    render();
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
